import { render, staticRenderFns } from "./DutyPositionEdit.vue?vue&type=template&id=6046297c"
import script from "./DutyPositionEdit.vue?vue&type=script&lang=js"
export * from "./DutyPositionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports